import LoyaltyFormulaExperience from "components/atoms/LoyaltyFormulaExperience";
import { useSelector } from "react-redux";
import { useGetExpSettingCurrency } from "queries/useGetExpSettingCurrency";
import { currentCurrency } from "../../redux/user/selectors";

const LoyaltyFormulaExperienceContainer = () => {
  const { exp } = useGetExpSettingCurrency();
  const currency = useSelector(currentCurrency);

  return (
    <LoyaltyFormulaExperience
      currency={currency}
      amount={exp?.cost || 0}
      experience={exp?.amount || 0}
    />
  );
};

export default LoyaltyFormulaExperienceContainer;
